const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;
const MANAGED = [
    'location',
    'locationOption',
    'group',
    'referenceOption',
    'squad',
    'operation',
    'tab',
    'view',
    'directory',
    'create',
];
function positiveInteger(value) {
    if (value == null || !/^[1-9]\d*$/u.test(value))
        return null;
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) ? parsed : null;
}
function parsedId(params, key, invalidKeys, allowed) {
    const raw = params.get(key);
    if (raw == null)
        return null;
    const id = positiveInteger(raw);
    if (!allowed || id == null) {
        invalidKeys.push(key);
        return null;
    }
    return id;
}
export function parseLocationView(params) {
    const invalidKeys = [];
    const rawCreate = params.get('create');
    const knownCreate = rawCreate === 'location' ||
        rawCreate === 'group' ||
        rawCreate === 'referenceOption' ||
        rawCreate === 'locationOption' ||
        rawCreate === 'squad'
        ? rawCreate
        : null;
    if (knownCreate === 'location') {
        for (const key of MANAGED) {
            if (key !== 'create' && params.has(key))
                invalidKeys.push(key);
        }
        return {
            locationId: null,
            locationOptionId: null,
            groupId: null,
            referenceOptionId: null,
            squadId: null,
            operationId: null,
            tab: 'main',
            directory: null,
            create: 'location',
            invalidKeys,
        };
    }
    if (rawCreate != null && knownCreate == null)
        invalidKeys.push('create');
    const rawLocation = params.get('location');
    let locationId = positiveInteger(rawLocation);
    if (rawLocation != null && locationId == null)
        invalidKeys.push('location');
    const isDirectories = params.get('view') === 'directories';
    const rawDirectory = params.get('directory');
    const directory = isDirectories &&
        (rawDirectory === 'groups' || rawDirectory === 'options' || rawDirectory === 'squads')
        ? rawDirectory
        : null;
    if ((params.has('view') || params.has('directory')) && directory == null) {
        if (params.has('view'))
            invalidKeys.push('view');
        if (params.has('directory'))
            invalidKeys.push('directory');
    }
    if (directory != null && rawLocation != null) {
        invalidKeys.push('location');
        locationId = null;
    }
    let locationOptionId = parsedId(params, 'locationOption', invalidKeys, locationId != null && directory == null);
    let groupId = parsedId(params, 'group', invalidKeys, (locationId != null && directory == null) || directory === 'groups');
    let referenceOptionId = parsedId(params, 'referenceOption', invalidKeys, locationOptionId != null || directory === 'options');
    let squadId = parsedId(params, 'squad', invalidKeys, locationOptionId != null || directory === 'squads');
    if (locationOptionId != null && groupId != null) {
        invalidKeys.push('group');
        groupId = null;
    }
    if (referenceOptionId != null && squadId != null) {
        invalidKeys.push('squad');
        squadId = null;
    }
    const rawOperation = params.get('operation');
    let operationId = rawOperation && UUID.test(rawOperation) ? rawOperation : null;
    if (rawOperation != null && operationId == null)
        invalidKeys.push('operation');
    const rawTab = params.get('tab');
    const tab = rawTab === 'translations' || rawTab === 'options' || rawTab === 'main' ? rawTab : 'main';
    if (rawTab != null && !['main', 'translations', 'options'].includes(rawTab)) {
        invalidKeys.push('tab');
    }
    let create = null;
    const createContextValid = (knownCreate === 'group' && directory === 'groups') ||
        (knownCreate === 'referenceOption' && directory === 'options') ||
        (knownCreate === 'squad' && directory === 'squads') ||
        (knownCreate === 'locationOption' &&
            locationId != null &&
            directory == null &&
            tab === 'options' &&
            rawTab === 'options');
    if (knownCreate && createContextValid) {
        create = knownCreate;
        const incompatible = knownCreate === 'group'
            ? [
                ['group', groupId],
                ['referenceOption', referenceOptionId],
                ['squad', squadId],
                ['operation', operationId],
            ]
            : knownCreate === 'referenceOption'
                ? [
                    ['group', groupId],
                    ['referenceOption', referenceOptionId],
                    ['squad', squadId],
                    ['operation', operationId],
                ]
                : knownCreate === 'squad'
                    ? [
                        ['group', groupId],
                        ['referenceOption', referenceOptionId],
                        ['squad', squadId],
                        ['operation', operationId],
                    ]
                    : [
                        ['locationOption', locationOptionId],
                        ['group', groupId],
                        ['referenceOption', referenceOptionId],
                        ['squad', squadId],
                        ['operation', operationId],
                    ];
        for (const [key, value] of incompatible) {
            if (value != null)
                invalidKeys.push(key);
        }
        if (knownCreate === 'group' || knownCreate === 'referenceOption' || knownCreate === 'squad') {
            groupId = null;
            referenceOptionId = null;
            squadId = null;
            operationId = null;
        }
        else {
            locationOptionId = null;
            groupId = null;
            referenceOptionId = null;
            squadId = null;
            operationId = null;
        }
    }
    else if (knownCreate) {
        invalidKeys.push('create');
    }
    return {
        locationId,
        locationOptionId,
        groupId,
        referenceOptionId,
        squadId,
        operationId,
        tab,
        directory,
        create,
        invalidKeys,
    };
}
function setId(params, key, value) {
    if (value === undefined)
        return;
    if (value === null)
        params.delete(key);
    else
        params.set(key, String(value));
}
export function setLocationView(current, patch) {
    const next = new URLSearchParams(current);
    if (patch.create !== undefined) {
        if (patch.create === null) {
            next.delete('create');
        }
        else {
            const locationId = patch.locationId === undefined ? positiveInteger(next.get('location')) : patch.locationId;
            for (const key of MANAGED)
                next.delete(key);
            if (patch.create === 'location') {
                next.set('create', patch.create);
            }
            else if (patch.create === 'locationOption') {
                if (locationId != null) {
                    next.set('location', String(locationId));
                    next.set('tab', 'options');
                    next.set('create', patch.create);
                }
            }
            else {
                const directory = patch.create === 'group'
                    ? 'groups'
                    : patch.create === 'referenceOption'
                        ? 'options'
                        : 'squads';
                next.set('view', 'directories');
                next.set('directory', directory);
                next.set('create', patch.create);
            }
            return next;
        }
    }
    if (patch.directory !== undefined) {
        for (const key of MANAGED)
            next.delete(key);
        if (patch.directory) {
            next.set('view', 'directories');
            next.set('directory', patch.directory);
        }
        return next;
    }
    if (patch.locationId !== undefined) {
        const changed = patch.locationId !== positiveInteger(next.get('location'));
        if (changed) {
            for (const key of [
                'locationOption',
                'group',
                'referenceOption',
                'squad',
                'operation',
                'tab',
            ]) {
                next.delete(key);
            }
        }
        setId(next, 'location', patch.locationId);
    }
    if (patch.locationOptionId !== undefined) {
        const changed = patch.locationOptionId !== positiveInteger(next.get('locationOption'));
        if (changed) {
            next.delete('referenceOption');
            next.delete('squad');
            next.delete('operation');
        }
        setId(next, 'locationOption', patch.locationOptionId);
    }
    setId(next, 'group', patch.groupId);
    setId(next, 'referenceOption', patch.referenceOptionId);
    setId(next, 'squad', patch.squadId);
    if (patch.operationId !== undefined) {
        if (patch.operationId === null)
            next.delete('operation');
        else
            next.set('operation', patch.operationId);
    }
    if (patch.tab !== undefined) {
        if (patch.tab === null || patch.tab === 'main')
            next.delete('tab');
        else
            next.set('tab', patch.tab);
    }
    return next;
}
